import React, { useState, useEffect } from 'react';

// custom components
import { SearchBar } from "_atoms";

// bootstrap
import { Dropdown } from 'react-bootstrap';

// redux
import { useSelector, useDispatch } from "react-redux";
import { setEmployeeFilter, selectEmployeeFilter, setEmployeeSearch, selectEmployeeSearchTerm, selectEmployeeSearchFilter, selectAddEmployeeStatus, resetAddEmployeeForm } from "_redux/slices/timeline/employees";
import { setSearchedFlight, selectSearchedFlight } from '_redux/slices/timeline/flight-information-list';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// styling
import { Spacing } from "_styles";
import { EmployeeInformationColumnWidth } from "_utils/timeline-constants";

// icons
import { selectBookingSearch, selectTaskStatusFilter, setBookingSearch, setTaskStatusFilter } from '_redux/slices/timeline/timeline-data';

const TimelineToolbar = () => {

    //#region redux
    const dispatch = useDispatch();

    const employeeFilter = useSelector(selectEmployeeFilter);                       // filter for employee list
    const searchTerm = useSelector(selectEmployeeSearchTerm);                       // holds the value of the employee search by name filter
    const employeeSearchFilter = useSelector(selectEmployeeSearchFilter);           // holds the value of the employee search by name filter
    const addEmployeeStatus = useSelector(selectAddEmployeeStatus);                 // status of adding employee
    const taskStatusFilter = useSelector(selectTaskStatusFilter);                   // task status filter(all, complete, active....)
    const searchedFlight = useSelector(selectSearchedFlight);
    const bookingSearch = useSelector(selectBookingSearch);
    const usedTheme = useSelector(selectUsedTheme);
    //#endregion

    //#region local states    
    const [showAddModal, setShowAddModal] = useState(false);                 // show add employee modal
    //#endregion

    //#region useEffect
    // adding employee handler
    useEffect(() => {
        if (addEmployeeStatus == "succeeded") {
            // employee successfully added, close modal
            handleCloseModal();
        }
    }, [addEmployeeStatus]);
    //#endregion

    //#region functions
    // modal close handler
    const handleCloseModal = () => {
        dispatch(resetAddEmployeeForm()); // reset form for next use
        setShowAddModal(false); // close modal
    };

    function capitalize(string) {
        if (string[0]) {
            return string[0].toUpperCase() + string.slice(1).toLowerCase();
        } else return string;
    }

    // const handleSearch = (val) => {
    //     if (val.target.value) {
    //         const searchedValue = val?.target?.value?.toUpperCase();
    //         dispatch(setSearchedFlight(searchedValue));
    //     } else {
    //         dispatch(setSearchedFlight(""));
    //     }
    // }
    const handleSearch = (val) => {
        if (val?.target?.value) {
            let searchValue = val?.target?.value?.replace(/\s+/g, '');
            const flightNumberRegex = /^([A-Za-z]{1,3}\d{2,4}[A-Za-z]?|\d+)$/i;
            if (flightNumberRegex.test(searchValue)) {
                dispatch(setSearchedFlight(searchValue));
                dispatch(setBookingSearch(""));

            } else {
                dispatch(setBookingSearch(searchValue));
            }
        } else {
            dispatch(setSearchedFlight(""));
            dispatch(setBookingSearch(""));

        }
    };

    const handleEmployeeSearch = (searchedValue) => {
        dispatch(setEmployeeFilter(searchedValue));
        dispatch(setEmployeeSearch(""))
    }
    //#endregion

    // if (show) {
    return (
        <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', backgroundColor: usedTheme.BACKGROUND_COLOR }}>

            {/* employee search filter */}
            <div style={{ display: 'flex', padding: Spacing.SCALE_4, flex: 1 }}>

                {/* Employee Status filter */}
                <Dropdown onSelect={(value) => handleEmployeeSearch(value)} data-tippy-content="Filter by Employee Status">
                    <Dropdown.Toggle
                        variant={usedTheme.BUTTON_VARIANT}
                        id="dropdown-basic"
                        style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, color: "gray", border: "1px solid", borderColor: usedTheme.BORDER_COLOR, width: EmployeeInformationColumnWidth, height: Spacing.SCALE_38, textAlign: "left", padding: "8px", marginLeft: Spacing.SCALE_2, marginTop: Spacing.SCALE_4, marginBottom: Spacing.SCALE_4, display: "flex", alignItems: "center", justifyContent: "space-between", }}
                    >
                        {employeeFilter ? employeeFilter.charAt(0).toUpperCase() + employeeFilter.slice(1) : "Select Status"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR }}>
                        {["all", "online", "offline", "busy", "available", "onBreak", "manual Search"].map((status) =>
                            <Dropdown.Item
                                style={{ color: usedTheme.TEXT_COLOR }}
                                eventKey={status}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = usedTheme.BORDER_COLOR;
                                    e.target.style.color = usedTheme.TEXT_COLOR;
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.color = usedTheme.TEXT_COLOR;
                                }}>
                                {`${status.charAt(0).toUpperCase()}${status.slice(1)}`}
                            </Dropdown.Item>)}
                    </Dropdown.Menu>
                </Dropdown>

                {employeeFilter === "manual Search" && <div style={{ padding: Spacing.SCALE_4 }}>
                    <SearchBar
                        employee={true}
                        // width={'10px'}
                        onChange={(event) => dispatch(setEmployeeSearch(event.target.value))}
                        placeholder={`Employee Filter`}
                        value={searchTerm}
                        timeline={true}
                    />
                </div>}

            </div>

            {/* search by pax / flights */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: Spacing.SCALE_4, flex: 1 }}>
                <SearchBar
                    onChange={(val) => handleSearch(val)}
                    placeholder={"Filter by Passenger Name / Flight Number"}
                    value={bookingSearch ? bookingSearch : searchedFlight}
                    timeline={true}
                />
            </div>

            {/* status toggles */}
            <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end', }}>

                {/* Task status filter */}
                <Dropdown onSelect={(value) => dispatch(setTaskStatusFilter(value))} data-tippy-content="Filter by Task Status">
                    <Dropdown.Toggle
                        variant={usedTheme.BUTTON_VARIANT}
                        id="dropdown-basic"
                        style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, color: "gray", border: "1px solid", borderColor: usedTheme.BORDER_COLOR, width: EmployeeInformationColumnWidth, height: Spacing.SCALE_38, textAlign: "left", padding: "8px", marginLeft: Spacing.SCALE_2, marginTop: Spacing.SCALE_4, marginBottom: Spacing.SCALE_4, display: "flex", alignItems: "center", justifyContent: "space-between", }}
                    >
                        {taskStatusFilter}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR }}>
                        {["all", "assigned", "active", "complete", "cancelled", "stopped"].map((status) =>
                            <Dropdown.Item
                                style={{ color: usedTheme.TEXT_COLOR }}
                                eventKey={status}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = usedTheme.BORDER_COLOR;
                                    e.target.style.color = usedTheme.TEXT_COLOR;
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.color = usedTheme.TEXT_COLOR;
                                }}>
                                {`${status?.charAt(0)?.toUpperCase()}${status?.slice(1)}`}
                            </Dropdown.Item>)}
                    </Dropdown.Menu>
                </Dropdown>

            </div>

        </div>
    );
};

export default TimelineToolbar;